import { Component, OnInit, Input } from '@angular/core';
import { Menu } from './menu';
import { MenuService } from './menu.service';


export class NavComponent implements OnInit {
  
  items: Menu[];

  constructor(private menuService: MenuService) { }

  ngOnInit() {
    if (!this.items || this.items.length === 0) {
      this.menuService.getData().subscribe(data => {
        this.items = data;
      });
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[leaf-layout-navbar]',
  template: `
  <ng-content select="[top-list-items]"></ng-content>
  <li *ngFor="let menu of items" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
    <a routerLink="{{menu.action}}">
      <i class="fa {{menu.icon}}"></i>
      <span class="nav-label ng-binding">{{menu.title}}</span>
      <span class="fa arrow" *ngIf="menu.items"></span>
    </a>
  </li>
  <ng-content select="[bottom-list-items]"></ng-content>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MenuService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'items': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
